import React from "react";

const CategoryItem = ({
  category,
  showMostPopular,
  selectedCategoryIndex,
  selectCategory,
  categoriesLength,
  idx,
}) => (
  <div className="cat-tag" key={idx}>
    <span className="separator">|</span>
    {category
      ? [
          <span
            style={{
              cursor: "pointer",
            }}
            className={
              selectedCategoryIndex === idx && !showMostPopular
                ? "clipped"
                : null
            }
            onClick={() => selectCategory(idx, category)}
          >
            {category}
          </span>,
          idx + 1 === categoriesLength ? (
            <span className="separator-end">|</span>
          ) : null,
        ]
      : [
          <input
            type="text"
            placeholder="Write a Category Name"
            className="trik"
          />,
          <span
            className="trik"
            style={{
              color: "var(--green)",
              fontSize: 16,
              cursor: "pointer",
            }}
          >
            +
          </span>,
        ]}
  </div>
);

const SubHeader = ({
  generalCategories = [],
  showSortableMenu,
  handleSort,
  openCustomSort,
  toggleSortable,
  addCategory,
  selectedCategory,
  selectedCategoryIndex,
  selectCategory,
  showMostPopular,
  toggleMostPopular,
  showUncategorized = true,
}) => {
  const goToAllCategory = () => {
    // TODO: Fix this change on Store Categories
    //! This was removed, the idea is to handle the 'all' categories option on the selectCategory callback
  };

  const generalCategoriesModified = [...generalCategories];
  if (showUncategorized) generalCategoriesModified.push("Uncategorized");

  return (
    <div className="general-categories-container">
      <div className="categories-header">
        <span className="title">
          Categories
          {generalCategoriesModified && generalCategoriesModified.length
            ? ` (${generalCategoriesModified.length})`
            : null}
        </span>
        <div className="sort-container active">
          <span
            style={{
              cursor: "pointer",
            }}
            onClick={() => toggleSortable()}
          >
            <img
              className="icon-green"
              alt="sort-icon"
              src="/img/svg/filter.svg"
            />
            Sort
          </span>
          {showSortableMenu ? (
            <div className="sort-options">
              <span className="sort-category-title">Sort Categories:</span>
              <div className="option" onClick={() => handleSort()}>
                <span>
                  <img
                    alt="asc"
                    src="/img/svg/ascending.svg"
                    className="icon-green"
                  />
                  Ascending
                </span>
              </div>
              <div className="option" onClick={() => handleSort("down")}>
                <span>
                  <img
                    alt="desc"
                    src="/img/svg/descending.svg"
                    className="icon-green"
                  />
                  Descending
                </span>
              </div>
              <div className="option last" onClick={() => openCustomSort()}>
                <span>
                  <img
                    alt="edit"
                    src="/img/svg/edit.svg"
                    className="icon-green"
                  />
                  Custom
                </span>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className="categories-container">
        <span
          onClick={() => {
            goToAllCategory();
            selectCategory("all", "All");
          }}
          style={{
            cursor: "pointer",
          }}
          className={
            selectedCategory === "All" && !showMostPopular ? "clipped" : ""
          }
        >
          All
        </span>
        {generalCategoriesModified &&
          generalCategoriesModified.map((category, idx) => (
            <CategoryItem
              idx={idx}
              category={category}
              showMostPopular={showMostPopular}
              selectedCategoryIndex={selectedCategoryIndex}
              selectCategory={selectCategory}
              categoriesLength={generalCategoriesModified.length}
            />
          ))}

        <span className="add-category" onClick={() => addCategory()}>
          Add Category
        </span>
      </div>
    </div>
  );
};

export default SubHeader;
